import { BasicBlocksPlugin, BasicMarksPlugin } from "@platejs/basic-nodes/react";
import { CodeBlockPlugin } from "@platejs/code-block/react";
import { ListPlugin } from "@platejs/list/react";
import {
  TableCellHeaderPlugin,
  TableCellPlugin,
  TablePlugin,
  TableRowPlugin,
} from "@platejs/table/react";
import { ImagePlugin } from "@platejs/media/react";
import { MarkdownPlugin } from "@platejs/markdown";
import {
  FontSizePlugin,
  FontColorPlugin,
  TextAlignPlugin,
} from "@platejs/basic-styles/react";
import remarkGfm from "remark-gfm";

// GFM (tables, strikethrough, task lists, autolinks) is not on by default
// in @platejs/markdown — without it, AI-generated markdown tables fall back
// to plain paragraphs of pipe-and-dash text. We always want GFM for policy
// content because the AI emits tables routinely.
const ConfiguredMarkdownPlugin = MarkdownPlugin.configure({
  options: {
    remarkPlugins: [remarkGfm],
  },
});

export const proposalPlugins = [
  BasicMarksPlugin,
  BasicBlocksPlugin,
  CodeBlockPlugin,
  ListPlugin,
  TablePlugin,
  TableRowPlugin,
  TableCellPlugin,
  TableCellHeaderPlugin,
  ImagePlugin,
  FontSizePlugin,
  FontColorPlugin,
  TextAlignPlugin,
  ConfiguredMarkdownPlugin,
];

// Named exports for toolbar use
export {
  FontSizePlugin,
  FontColorPlugin,
  TextAlignPlugin,
};
